import http from '@/axios.js'

const state = {
	user: {
		first_name: null,
		last_name: null,
		email: null,
		memberships: [],
		selected_membership: null,
		id: null,
		is_staff: false,
		viewed_tours: {},
	},
	organizationDetails: {
		billing_enabled: false,
		lms_auth_enabled: undefined,
		lms_grade_passback_enabled: false,
		max_users: 0,
		max_learner_users: 0,
		max_creator_users: 0,
		user_management_mode: "learners_and_creators",
		max_cases: null,
		max_pages: null,
		active_user_count: 0,
		free_tier_active: true,
		pricing_tier: null,
		ff_lms_integration: false,
		lms_default_vendor_type: null,
		monthly_learner_counts: {},
		lms_instances: [],
		logo_image: null,
	},
}

const getters = {
	userFirstName: state => {
		return state.user.first_name
	},
	userFullName: state => {
		return state.user.first_name + ' ' + state.user.last_name
	},
	userEmail: state => {
		return state.user.email
	},
	userRole: state => {
		if (!state.user.selected_membership) {
			return null
		}
		return state.user.selected_membership.role
	},
	userIsOrganizationAdmin: state => {
		if (!state.user.selected_membership) { return false }
		return state.user.selected_membership.role === 'admin'
	},
	user: state => {
		return state.user
	},
	hasAcceptedCommunityTerms: state => {
		return state.user.has_accepted_community_terms
	},
	userIsAnonymous: state => {
		return !state.user.email
	},
	memberships: state => {
		return state.user.memberships
	},
	activeMembership: state => {
		return state.user.selected_membership
	},
	currentOrganization: state => {
		if (state.user.selected_membership) {
			return state.user.selected_membership.organization
		}
		return {}
	},
	currentOrganizationId: state => {
		if (!state.user.selected_membership) {
			return null
		}
		return state.user.selected_membership.organization.id
	},
	organizationBillingEnabled: state => {
		return state.organizationDetails && state.organizationDetails.billing_enabled
	},
	organizationLMSAuthConfigured: state => {
		return state.organizationDetails && state.organizationDetails.lms_auth_enabled
	},
	organizationLMSGradePassbackEnabled: state => {
		return state.organizationDetails && state.organizationDetails.lms_grade_passback_enabled
	},
	organizationDetails: state => {
		return state.organizationDetails
	},
	freeTierActive: state => {
		return state.organizationDetails.free_tier_active
	},
	organizationLMSInstances: state => {
		return state.organizationDetails.lms_instances
	},
	freeTierMembership: state => {
		return state.user.memberships.find(m => m.organization.free_tier_active)
	},
	currentPricingTier: state => {
		return state.organizationDetails.pricing_tier
	},
	currentPricingTierName: state => {
		let name = String(state.organizationDetails.pricing_tier)
		// Capitalize the first letter.
		return name.charAt(0).toUpperCase() + name.slice(1)
	},
}

const mutations = {
	setUser: (state, user) => {
		state.user = user
	},
	setOrganizationDetails: (state, organization) => {
		state.organizationDetails = organization
	},
	setTourViewed: (state, tourName) => {
		state.user.viewed_tours[tourName] = true
	},
}

const actions = {
	fetchAuth: (context) => {
		return new Promise((resolve) => {
			http.get('/api/auth/')
				.then(function (response) {
					if (response.data) {
						context.commit('setUser', response.data)
					}
					resolve(response)
				})
		})
	},
	fetchOrganizationDetails: (context) => {
		return new Promise((resolve) => {
			http.get(`/api/organizations/${context.state.user.selected_membership.organization.id}/`)
				.then(function (response) {
					context.commit('setOrganizationDetails', response.data)
					resolve(response)
				})
		})
	},
	setTourViewed: (context, tourName) => {
		http.put("/api/tour-viewed/", { tourId: tourName })
		context.commit('setTourViewed', tourName)
	},
}

export default {
	state,
	getters,
	mutations,
	actions
}
